"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WithdrawalInit = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var hsAccount_1 = require("../../model/hsAccount");
var service_1 = require("../../../library/base/service");
var WithdrawalInit = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(WithdrawalInit, _super);
    function WithdrawalInit() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '账户余额提现初始化接口';
        _this.code = '105002';
        _this.desc = '账户余额提现初始化接口';
        _this.requestParams = new hsAccount_1.WithdrawalInitRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return WithdrawalInit;
}(service_1.BaseService));
exports.WithdrawalInit = WithdrawalInit;
//# sourceMappingURL=withdrawalInit.js.map